<template>
    <div>

        <config-main-title>
            {{ titulo }}
        </config-main-title>

        <div class="form-row">
            <div class="col col-12" :class="( tipo == 'medicamento' && !infusao ) 
                ? 'col-md-4' 
                : ( ( tipo == 'procedimento' ) ? 'col-md-5' : 'col-md-7' )">
                
                <div class="input-group mb-1" v-if="!config && $store.state.user.medico">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-user-md fa-fw"></i>
                        </span>
                    </div>
                    <label class="form form-control" disabled>{{ $store.state.user.medico.search }}</label>
                </div>

                <az-input
                    v-else
                    placeholder="Geral..."
                    icon="fas fa-user-md fa-fw"
                    type="select"
                    optionsMode="aql"
                    service="medicos.index"
                    optionsName="medicos-cadastro"
                    :optionsParm="{ ativos: true }"
                    v-model="medico"
                    @change.native="selecionarMedico()" />
            </div>
            <div class="col col-12 col-md-3">
                <az-input
                    :edicao="!$store.state.user.id_unidade_operacao"
                    icon="fa fa-building fa-fw"
                    type="select"
                    placeholder="Todas as Unidades..."
                    :optionsList="$util.unidades_com_tags(true, true)"
                    optionsData="id_unidade_operacao"
                    v-model="id_unidade_operacao"
                    @input="selecionarMedico()">
                </az-input>
            </div>
            <div class="col col-12 col-md-3" v-if="tipo == 'medicamento' && !infusao">
                <i class="" aria-hidden="true"></i>
                <az-input
                    icon="fa fa-filter"
                    placeholder="Todos os Tipo..."
                    type="select"
                    :optionsList="[
                        { id: 'R', search: 'Receita' },
                        { id: 'P', search: 'Prescrição' },
                    ]"
                    optionsData="id"
                    v-model="tipo_kit" />
            </div>
            <div class="col col-12 col-md-2 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()" :disabled="medico ? true : false">
                    Incluir {{ infusao ? 'Protocolo' : 'Kit' }}
                </button>
            </div>

            <div class="col col-12 col-md-2 d-flex flex-column" v-if="tipo == 'procedimento' && !infusao" :disabled="medico ? true : false">
                <button type="button" class="btn btn-outline-success" @click="incluir (true)">
                    Incluir Kit de Cirurgia
                </button>
            </div>
        </div>

        <div class="form-row mt-2 mb-3">
            <div class="col col-12">
                <az-input
                    icon="fa fa-search fa-fw" 
                    placeholder="Pesquisar..."
                    v-model="search">

                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="!$store.state.user.medico">
                            <button type="button" class="btn btn-outline-primary" title="Incluir Profissionais" @click="incluir_medico_bloco()">
                                <i class="fa-solid fa-user-plus"></i>
                            </button>
                            <button type="button" class="btn btn-outline-danger" title="Incluir Profissionais" @click="remover_medico_bloco()">
                                <i class="fa-solid fa-user-minus"></i>
                            </button>

                            <importacao service="kit_medicamentos" name="kit-medicamentos" v-if="!medico" />
                        </div>

                        <!--
                        <div class="input-group-append" v-else>
                            <button type="button" class="btn btn-outline-primary" title="Incluir Profissionais" @click="editar_lista_docs()">
                                <i class="fa-solid fa-list-check"></i>
                            </button>
                        </div>
                        -->
                    </template>

                </az-input>
            </div>
        </div>

        <table class="table table-sm border-0 table-responsive mb-1">
            <tr>
                <td class="text-nowrap">
                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                        <span class="badge badge-success mr-1" >
                            {{ classe }}
                        </span>
                    </a>
                </td>
            </tr>
        </table>

        <template v-if="!lista || !lista.length">
            <az-empty-state msg="Nenhum kit cadastrado." />
        </template>

        <ul class="list-group" v-else>
            <li class="list-group-item d-flex justify-content-between" v-for="(kit, ikit) in lista" :key="ikit">
                <div>
                    <a href="#" @click.prevent="editar(kit)" class="card-link">
                        {{ kit.st_nome }}
                    </a>
                    <div v-if="kit.js_classes && kit.js_classes.length">
                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in kit.js_classes" :key="icx">
                            <span class="badge badge-success mr-1">
                                {{ classe }}
                            </span>
                        </a>
                    </div>
                </div>
                <div>
                    <span v-if="kit.fl_ciclos">
                        <i class="fas fa-syringe text-primary mr-3" title="Infusão"></i>
                    </span>
                    <span v-else-if="kit.st_tipo == 'R'">
                        <i class="fas fa-prescription text-primary mr-3" title="Receita"></i>
                    </span>
                    <span v-else-if="kit.st_tipo == 'P'">
                        <i class="fas fa-pills text-primary mr-3" title="Prescrição"></i>
                    </span>
                    
                    <span class="badge badge-secondary mr-3" title="Quantidade de itens.">
                        {{ kit.items.length }}
                    </span>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" 
                        data-toggle="tooltip" data-placement="top" title="Profissionais Habilitados"
                        @click="medico_lista(kit)">
                        <i class="fas fa-user-md"></i>

                        <span class="badge badge-primary ml-1" data-toggle="tooltip" data-placement="top" title="Profissionais Selecionados"
                            v-if="kit.medico_lista.length">
                            {{ kit.medico_lista.length }}
                        </span>

                        <span class="text-warning ml-1" data-toggle="tooltip" data-placement="top" title="Nenhum profissional selecionado."
                            v-if="!kit.id_medico && !kit.medico_lista.length">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </span>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" v-if="kit.unidade_operacao_lista"
                        data-toggle="tooltip" data-placement="top" title="Unidades Habilitadas"
                        @click="unidade_operacao_lista(kit)">
                        <i class="fa-regular fa-building"></i>

                        <span class="badge badge-primary ml-1" title="Unidades Selecionados" v-if="kit.unidade_operacao_lista.length">
                            {{ kit.unidade_operacao_lista.length }}
                        </span>
                    </button>

                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" 
                        data-toggle="tooltip" data-placement="top" title="Clonar Kit"
                        @click="clonar_kit(kit)">
                        <i class="fas fa-copy"></i>
                    </button>

                    <button type="button" class="btn btn-outline-danger btn-sm mr-2" 
                        data-toggle="tooltip" data-placement="top" title="Remover Kit"
                        @click="remover(kit)">
                        <i class="far fa-trash-alt"></i>
                    </button>

                    
                </div>
            </li>
        </ul>

        <pre v-if="1 == 0">{{ dados }}</pre>

        <order-set
            :id_unidade_operacao="id_unidade_operacao"
            :tem_infusao="infusao ? true : false"
            :title="titulo"
            v-model="item"
            :service="service"
            :name="name"
            ref="editkit"
            :kit="true"
            :cirurgia="is_cirurgia(item)"
            :infusao="infusao"
            @refresh="load()" />

        <medico-lista ref="medicolista" @refresh="load()" />
        <unidade-operacao-lista ref="unidadeoperacaolista" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import OrderSet from '../OrderSet.vue';
import MedicoLista from '../../../shared/MedicoLista.vue';
import UnidadeOperacaoLista from '../../../shared/UnidadeOperacaoLista.vue';
import Importacao from '../../../cadastros/shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: [],
            item: null, 
            validate: false,
            novo_item: null, 
            service: "", 
            name: null, 
            search: "", 
            tipo_kit: "",
            medico: "", 
            id_unidade_operacao: "", 
        }
    },

    props: ['tipo', 'config', 'infusao'],

    computed: { 
        lista_classes: function () { 
            if ( !this.dados )
                return [];

            return _.uniq(this.dados.flatMap(item => item.js_classes ? item.js_classes : [])).sort();
        },

        caps: function () { 
            return ( this.tipo ? this.tipo[0].toUpperCase() + this.tipo.substring(1) : '?' );
        },

        titulo: function () { 
            return this.infusao 
                ? 'Protocolo de Infusão' 
                : 'Kit de ' + ( this.tipo ? this.tipo[0].toUpperCase() + this.tipo.substring(1) : '?' );
        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length 
                ? this.dados.filter(item => ( this.tipo_kit != 'I' || item.fl_ciclos )
                        && ( ( this.tipo_kit != 'R' || ( ( item.st_tipo == 'G' || item.st_tipo == 'R' ) && !item.fl_ciclos ) ) )
                        && ( ( this.tipo_kit != 'P' || ( ( item.st_tipo == 'G' || item.st_tipo == 'P' ) && !item.fl_ciclos ) ) ) 
                    )
                    .filter (item => { 
                        return ( !this.search || reg.test(JSON.stringify(item)) );
                    }) 
                : null;
        },
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState,
        OrderSet, 
        MedicoLista,
        AzInput, 
        UnidadeOperacaoLista, 
        Importacao,
    },  

    watch: { 
        tipo: function (newVal, oldVal) { 
            if ( oldVal && newVal != oldVal ) { 
                this.init();
            }
        }
    },

    methods: { 
        filtrar(texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        selecionarMedico () { 
            this.load();
        },

        incluir_medico_bloco () { 
            this.$refs.medicolista.abrir('kit' + this.caps, this.lista.map(item => item['id_kit_' + this.tipo]));
        },

        remover_medico_bloco () { 
            this.$refs.medicolista.abrir('kit' + this.caps, this.lista.map(item => item['id_kit_' + this.tipo]), true);
        },

        is_cirurgia (item) { 
            if ( !item )
                return false;

            return ( item.cirurgia || item.items.find(rp => rp.item && rp.item.id_classe_procedimento == 2) )  
                ? true : false;
        },

        medico_lista (kit) { 
            this.$refs.medicolista.abrir('kit' + this.caps, kit['id_kit_' + this.tipo]);
        },

        unidade_operacao_lista (kit) { 
            this.$refs.unidadeoperacaolista.abrir('kit' + this.caps, kit['id_kit_' + this.tipo]);
        },

        remover(item) { 
            if ( !confirm("Confirma remover o kit: '" + item.st_nome + "'?") )
                return;

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'remover_kit', 
                dados: { 
                    type: this.name,
                    dados: item,
                },
                callback: () => { 
                    this.load();
                }
            });  
        },
        incluir_item(item = null) {

            if ( !item && !this.novo_item ) { 
                return;
            }

            let novo_item;

            if ( item ) { 
                novo_item = item.item;
                item = item.item ? item.item : {};
            } else { 
                novo_item = this.novo_item;   
                item = this.novo_item;
            }

            if ( this.novo_item )
                this.novo_item = "";

            if (novo_item) {
                this.item.items.push({
                    item: novo_item,
                    st_posologia: novo_item.st_posologia, 
                    in_quantidade: novo_item.in_quantidade, 
                    id_apresentacao: novo_item.id_apresentacao, 
                    st_observacoes: "",
                    incluir: true, 
                });

                this.$nextTick(() => {
                    if ( this.novo_item !== null ) { 
                        this.novo_item = null;
                    }
                });
            }

        },

        editar(item) { 

            if ( item.id_kit_medicamento || item.id_kit_procedimento ) { 

                this.$util.load(this, { 
                    service: 'kit_' + this.tipo + 's',
                    parms: { 
                        cadastro: true, 
                        infusao: this.infusao,
                        id_medico: this.medico ? this.medico.id_pessoa : null,
                        id_kit_medicamento: item.id_kit_medicamento,
                        id_kit_procedimento: item.id_kit_procedimento, 
                        id_unidade_operacao: this.id_unidade_operacao ? this.id_unidade_operacao : null,
                    },
                    loadTo: res => { 
                        if ( res && res.length == 1 ) {

                            /*
                            if ( res[0].js_classes ) { 
                                res[0].js_classes = [];
                            }
                            */

                            this.item = res[0];

                            if ( this.tipo == 'procedimento' ) { 
                                if ( !this.item.items.find(item => item.in_regra_ordem !== null) ) { 
                                    this.item.items = _.orderBy(this.item.items, 'item.search');
                                }

                                if ( this.is_cirurgia(item) && !this.item.materiais ) { 
                                    this.item.materiais = [];
                                }
                            }
                            
                            this.$nextTick(() => { 
                                this.$refs.editkit.abrir();
                            });

                        } else { 
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: 'Falha na identificação do item.',
                                life: 3000
                            });
                        }
                    }
                });

                return;

            }

            this.item = { ...item };

            if ( !this.item.js_classes ) { 
                this.item.js_classes = [];
            }
            
            if ( this.tipo == 'procedimento' ) { 
                if ( !this.item.items.find(item => item.in_regra_ordem !== null) ) { 
                    this.item.items = _.orderBy(this.item.items, 'item.search');
                }

                if ( this.is_cirurgia(item) && !this.item.materiais ) { 
                    this.item.materiais = [];
                }
            }
            
            this.$nextTick(() => { 
                this.$refs.editkit.abrir();
            });
        },

        clonar_kit (kit) { 
            this.item = _.cloneDeep(kit);

            if ( this.tipo == 'procedimento' ) { 
                this.item.id_kit_procedimento = null;
            } else { 
                this.item.id_kit_medicamento = null;
            } 

            this.item.medico_lista = [];

            this.item.items.forEach(item => { 
                if ( this.tipo == 'procedimento' ) { 
                    item.id_kit_procedimento = null;
                    item.id_item_kit_procedimento = null;
                } else { 
                    item.id_kit_medicamento = null;
                    item.id_item_kit_medicamento = null;

                    if ( item.diluidos && item.diluidos.length ) { 
                        item.diluidos.forEach(dil => { 
                            dil.id_kit_medicamento = null;
                            dil.id_item_kit_medicamento = null;
                            dil.id_item_kit_medicamento_dil = null;
                        });
                    }
                } 
            });

            if ( this.item.materiais && this.item.materiais.length ) { 
               this.item.materiais.forEach(item => { 
                    item.id_kit_procedimento = null;
                    item.id_kit_procedimento_material = null;
                }); 
            }

            this.item.st_nome = 'Cópia de ' + this.item.st_nome;

            this.$nextTick(() => { 
                this.$refs.editkit.abrir();
            });
        },

        incluir(cirurgia = false) { 
            this.item = { 
                id: null, 
                st_nome: "", 
                st_tipo: "G",
                cirurgia: cirurgia, 
                materiais: [], 
                items: [],
                js_classes: [], 
                cid: null,
                cid2: null, 
                cid3: null, 
            }

            this.$nextTick(() => { 
                this.$refs.editkit.abrir();
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'kit_' + this.tipo + 's',
                // with: ['medico_lista'],
                parms: { 
                    cadastro: true, 
                    config: this.config ? true : false,
                    infusao: this.infusao,
                    id_medico: this.medico ? this.medico.id_pessoa : null,
                    id_unidade_operacao: this.id_unidade_operacao ? this.id_unidade_operacao : null,
                }
            });
        },

        init() { 
            this.name = this.tipo == 'procedimento' ? 'requisicao' : 'receita';
            this.service = this.tipo + 's.index';
            this.load();
        }
    },

    mounted() { 
        this.init();

        this.$util.loadItem(this, {
            service: 'pep',
            func: 'order_set_stats',
        })
        .then(res => { 
            this.$store.commit('setOptions', { name: 'order_set_stats', list: res });
        });

        // 

        if ( this.config ) { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: this.titulo },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        } else { 

            this.breadcrumb = [
                    { name: this.titulo },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        //

        if ( this.infusao ) { 
            this.tipo_kit = 'I';
        }
    },

    updated() { 
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>